module.exports = "  <ul>\n    <li><router-link to=\"/preins\">Formulaire de pré-inscription en ligne</router-link></li>\n  </ul>\n"